// extracted by mini-css-extract-plugin
export var container = "_mg-0";
export var segment = "_mg-2";
export var segmentActive = "_mg-3";
export var track = "_mg-1";